export const searchPageUrl = "/search";
export const flightsPageUrl = "/flights";
